import axios, { endpoints } from 'src/utils/axios';

export const adminApiService = {
    async signIn(email, password) {
        try {
            const response = await axios.post(endpoints.auth.adminSignIn, {email,  password});

            if (response.data.status !== 'success') {
                throw new Error(response.data.message || 'Login failed');
            }

            return response.data.data;
        } catch (error) {
            console.error('Admin sign in error:', error);
            throw error;
        }
    },

    // Get admin profile
    async getProfile() {
        try {
            const response = await axios.get(endpoints.auth.profile);
            return response.data.data;
        } catch (error) {
            console.error('Get profile error:', error);
            throw error;
        }
    },

    // Update admin profile
    async updateProfile(profileData) {
        try {
            const response = await axios.put(endpoints.auth.profile, profileData);
            return response.data.data;
        } catch (error) {
            console.error('Update profile error:', error);
            throw error;
        }
    },

    // Change password
    async changePassword(currentPassword, newPassword) {
        try {
            const response = await axios.post(endpoints.auth.changePassword, {
                current_password: currentPassword,
                new_password: newPassword,
            });
            return response.data;
        } catch (error) {
            console.error('Change password error:', error);
            throw error;
        }
    },
};
